var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99999 12.0002C3.99999 11.7442 4.09799 11.4882 4.29299 11.2932L9.29299 6.29325C9.68399 5.90225 10.316 5.90225 10.707 6.29325L15.707 11.2933C16.098 11.6842 16.098 12.3163 15.707 12.7073C15.316 13.0982 14.684 13.0982 14.293 12.7073L9.99999 8.41425L5.70699 12.7072C5.31599 13.0982 4.68399 13.0982 4.29299 12.7072C4.09799 12.5122 3.99999 12.2562 3.99999 12.0002Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "90bcf69231fe65986239ef51e009f1aa.svg";
export { ForwardRef as ReactComponent };